<template>
  <div>
    <div class="claim-card card">
      <div :class="type != 'nfp' ? 'user' : 'user-2'">
        <div :class="type != 'nfp' ? 'avatar-cont' : 'avatar-cont-2'">
          <a-avatar
            @click="routeToProfile()"
            :style="{
              color: ' #ffffff !important',
              'background-color': getAvatarColor(info.ext_ref_id),
              display: 'flex',
              'align-items': 'center',
              cursor: 'pointer',
            }"
            :size="70"
            :src="info.picture ? info.picture : null"
            alt="avatar image"
            class="text-capitalize"
          >
            {{ info.searchName[0] }}
          </a-avatar>
          <div v-if="type != 'nfp' && type != 'buisness'" class="rating-cont">
            <ReviewStar :rating="Number(info.mycircle_rating ? ((info.mycircle_rating || 0) + (info.rating || 0)) / 2 : info.rating || 0)" :height="16" :width="16" />
            <!-- <ReviewStar :rating="Number(info.rating ? info.rating.toFixed(2) : 0)" :height="16" :width="16" /> -->
            <!-- <ReviewStar :rating="Number(info.mycircle_rating ? info.mycircle_rating.toFixed(2) : 0)" :height="16" :width="16" /> -->
            <span class="rating-text">{{ info.mycircle_rating ? (((info.mycircle_rating || 0) + (info.rating || 0)) / 2).toFixed(2) : (info.rating || 0).toFixed(2) }} stars</span>
            <!-- <span class="rating-text">{{ info.rating ? info.rating.toFixed(2) : 0 }} stars</span> -->
            <!-- <span class="rating-text">{{ info.mycircle_rating ? info.mycircle_rating.toFixed(2) : 0 }} stars</span> -->
            <span class="rating-text">{{ (info.review_count || 0) + (info.ratingCount || 0) }} reviews</span>
            <!-- <span class="rating-text">{{ info.review_count ? info.review_count : 0 }} reviews</span> -->
          </div>
        </div>
        <div class="divider"></div>
        <div class="right-items profile-btn item">
          <div :class="type != 'nfp' ? 'title-cont' : 'title-cont-2'">
            <div class="d-flex flex-row" :style="{ gap: '8px' }">
              <div class="d-flex flex-row recommended" :style="{ background: '#F1EDFF', gap: '4px' }">
                <i class="fa fa-thumbs-up fa-lg" :style="{ color: '#906EFF' }" aria-hidden="true"></i>
                <p class="rec-text">Recommended</p>
              </div>
              <div class="crown-tag" :style="{ background: '#FFF0D6', width: '30px', height: '22px' }">
                <font-awesome-icon size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: #f5a623" :icon="['fas', 'crown']" />
              </div>
            </div>
            <p
              class="bold-text cp extra"
              :style="{
                color: '#0F1734',
                'font-weight': '700',
                'font-size': '20px',
                'line-height': '30px',
                'margin-bottom': '4.5px',
              }"
              @click="routeToProfile()"
            >
              {{ info.searchName }}
            </p>
            <span class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">
              {{ info.speciality }}
            </span>
          </div>
          <div :class="type != 'nfp' ? 'midl-cont' : 'midl-cont-2'">
            <span v-if="info.phoneNumber" class="text-norm">
              <font-awesome-icon size="1x" :icon="['fal', 'phone-alt']" :style="{ color: '#94A3B8' }" />
              {{ FormatPhoneNumber(info.phoneNumber) }}
            </span>
            <span v-if="info.address" class="loc-text">
              <font-awesome-icon size="1x" :icon="['fal', 'map-marker-alt']" :style="{ color: '#94A3B8' }" />
              <div class="loc-cont">
                <span class="loc-add">
                  {{ info.address }}
                </span>
              </div>
            </span>
            <span v-if="info.distance" class="text-norm2">
              {{ info.distance ? info.distance[0].toFixed(2) : 0 }}
              miles away
            </span>
          </div>
          <!-- <div class="meet-others">
              <div class="btn-container1">
                <div
                  :disable="addCircleButtonText === 'In your circle'"
                  class="btn-primary1"
                  v-bind:style="
                    addCircleButtonText === 'In your circle'
                      ? {
                          background: '#E2E8F0',
                          'pointer-events': 'none',
                          width: '161px',
                          color: '#47556E',
                          'align-items': 'center',
                          'justify-content': 'center',
                          gap: '4px'
                        }
                      : { background: getPrimaryColor(), cursor: 'pointer' }
                  "
                  @click="addVirtualDocToCircle(info)"
                >
                  <div
                    v-if="
                      loadingbtn === info.id
                        ? info.id
                        : this.affiliatedId
                        ? this.affiliatedId
                        : this.$route.params.id
                    "
                    class="spinner-border spinner-border2 position-absolute spinner-class"
                  ></div>
                  <font-awesome-icon
                    v-if="addCircleButtonText === 'In your circle'"
                    size="lg"
                    :style="{ transform: 'scale(1.0)', color: '#47556E' }"
                    :icon="['fal', 'check']"
                  />
                  {{ addCircleButtonText }}
                </div>
              </div>
            </div> -->
        </div>
        <div v-if="loading === this.info.id" class="spinnerContainer2">
          <a-spin size="large" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserRepository from "../../../repositories/userRepository.js"
import ReviewStar from "../../commons/ReviewStar.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCheck } from "@fortawesome/pro-light-svg-icons"
import { faThumbsUp, faCrown } from "@fortawesome/pro-solid-svg-icons"

library.add(faCheck, faThumbsUp, faCrown)

export default {
  name: "DoveMedRecommendedCard",
  components: {
    ReviewStar,
  },
  data() {
    return {
      loadingbtn: null,
      loading: false,
      addCircleButtonText: this.info.on_circle ? "In your circle" : "Add To Circle",
    }
  },
  created() {
    this.info = { ...this.info, id: this.info.id.slice(1) }
  },
  methods: {
    addVirtualDocToCircle(info) {
      const id = info.id ? info.id : this.affiliatedId ? this.affiliatedId : this.$route.params.id
      this.loadingbtn = id
      const idParam = this.type === "doctor" || this.type === "hospital_administrator" || this.type === "clinic_administrator" || this.type === "nfp_administrator" ? info : id
      UserRepository.addUserByTypeToCircle(idParam, this.currentCircle.id, this.type)
        .then(res => {
          this.loadingbtn = false
          this.$notification.success({ message: "Success", description: res.data.message })
          this.addCircleButtonText = "In your circle"
        })
        .catch(err => {
          this.$notification.info({
            message: "Information",
            description: err.response.data.message,
          })
          if (err.response.data.message == "already added") {
            this.addCircleButtonText = "In your circle"
          }
          this.loadingbtn = false
          //this.addCircleButtonText = "ADD TO CIRCLE";
        })
      //this.$emit("addVirtualDocToCircle", info);
    },

    FormatPhoneNumber(val) {
      let output = "("
      val.replace(/^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function(match, g1, g2, g3) {
        if (g1.length) {
          output += g1
          if (g1.length == 3) {
            output += ")"
            if (g2.length) {
              output += " " + g2
              if (g2.length == 3) {
                output += "-"
                if (g3.length) {
                  output += g3
                }
              }
            }
          }
        }
      })
      return output
    },
    routeToProfile() {
      this.loading = this.info.id
      if (Number(this.info.ext_ref_id) === this.authUser.user.ext_ref_id && this.info.role === this.authUser.user.role) {
        switch (this.type) {
          case "hospital_administrator":
            this.$router.push({ name: "HosAbout" })
            break
          case "hcp":
            this.$router.push({ name: "HcpAbout" })
            break
          case "nfp_administrator":
            this.$router.push({ name: "NFPAbout" })
            break
          case "clinic_administrator":
            this.$router.push({ name: "ClinicAbout" })
            break
          case "doctor":
            this.$router.push({ name: "DocUpdates" })
            break
          case "Business":
            break
          default:
            this.$router.push({ name: "DocUpdates" })
            break
        }
      } else {
        let data = { ...this.info, role: this.type }
        console.log(data, "data in routing card")
        switch (this.type) {
          case "physician":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "doctor",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({
                  ...this.info,
                  role: "doctor",
                  id: this.info.id,
                })
            break
          case "doctor":
            console.log("doctor")
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "doctor",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({
                  ...this.info,
                  role: "doctor",
                  id: this.info.id,
                })
            break
          case "providers":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "doctor",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : data.ext_ref_id
              ? this.viewEntityProfile({ ...this.info, role: "doctor" })
              : this.viewProfile({
                  ...this.info,
                  role: "doctor",
                  id: this.info.id,
                })
            break
          case "other":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "hcp",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...this.info, role: "hcp" })
            break
          case "hcp":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "hcp",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...this.info, role: "hcp" })
            break
          case "hcp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "hcp",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...this.info, role: "hcp" })
          case "hospital":
            this.info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...this.info,
                    role: "hospital_administrator",
                    id: this.info.my_circles_id,
                    ext_ref_id: null,
                  })
                : this.viewEntityProfile({ ...this.info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "hospital_administrator",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewProfile({
                  ...this.info,
                  role: "hospital_administrator",
                  id: this.info.id,
                })
            break
          case "hospital_administrator":
            this.info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...this.info,
                    role: "hospital_administrator",
                    id: this.info.my_circles_id,
                    ext_ref_id: null,
                  })
                : this.viewEntityProfile({ ...this.info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "hospital_administrator",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewProfile({
                  ...this.info,
                  role: "hospital_administrator",
                  id: this.info.id,
                })
            break
          case "clinic":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "clinic",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile(data)
            break
          case "clinic_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "clinic",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...this.info, role: "clinic" })
            break
          case "nfp":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "nfp",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile(data)
            break
          case "nfp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...this.info,
                  role: "nfp",
                  id: this.info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...this.info, role: "nfp" })
            break
          case "Business":
            this.loading = false
            break
        }
      }
    },
  },

  props: {
    info: Object,
    type: String,
    affiliatedId: Number,
    fetchDoc: Function,
  },
}
</script>

<style lang="scss" scoped>
.loc-add {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
}
.crown-tag {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rec-text {
  align-self: center;
  margin-bottom: 0px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #906eff;
}
.recommended {
  padding: 4px 8px;
  height: 22px;
  width: 115px;
}
.spinnerContainer2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
}

.spinner-border2 {
  width: 1rem !important;
  height: 1rem !important;
}
.user {
  align-items: center;
  width: 100%;
  overflow: hidden;
  display: flex;
}

.user-2 {
  align-items: normal;
  width: 100%;
  overflow: hidden;
  display: flex;
}
.card {
  margin-bottom: 16px;
  border: 1px solid #e2e8f0 !important;
  flex-direction: row !important;
}

.divider {
  width: 1px;
  height: 100%;
  background-color: #cbd5e1;
  @media screen and (max-width: 1200px) {
    margin-top: 0px;
  }
}

.btn-container1 {
  .btn-primary1 {
    border-radius: 6px;
    color: #ffffff;
    font-family: Lato;
    font-size: 14px;
    line-height: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    padding: 12px 24px;
    max-width: 161px;
    min-width: 132px;

    @media screen and (max-width: 900px) {
      padding: 7px 5px;
    }
  }
  .btn-secondary1 {
    border-radius: 17.5px;
    color: #f5b255;
    margin-top: 10px;
    background: #fff;
    font-family: Lato;
    font-size: 12px;
    padding: 5px 6px;
    font-weight: bold;
    text-align: center;
    max-width: 126px;
    min-width: 99px;
  }
}
.meet-others {
  display: flex;
  align-items: center;
  button {
    display: flex;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    // width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    @media screen and (max-width: 1200px) {
      margin-left: 15.5px;
      justify-content: center;
      width: 100%;
    }
  }
  span {
    font-size: 14px !important;
  }
}
.title-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 17px;
  @media screen and (min-width: 1201px) {
    width: 210.5px;
    gap: 8px;
  }
}

.title-cont-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 17px;
  // margin-top: -24px;
  @media screen and (min-width: 1201px) {
    width: 210.5px;
    gap: 8px;
  }
}

.extra {
  // width: 213.5px;
  @media screen and (max-width: 1200px) {
    width: 100%;
  }
}
.middle-item-cont {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  @media screen and (max-width: 1200px) {
    flex-direction: column;
    width: 100%;
  }
}

.item {
  gap: 20px;
  display: flex;
  padding: 24px;
  @media screen and (max-width: 1200px) {
    flex-direction: column;
    width: 100%;
    margin-left: 0px;
    padding: 20px 10px 10px 15px;
  }
}
.text-norm2 {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  margin-left: 18px;
}
.text-norm {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  gap: 8px;
}

.loc-text {
  gap: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.midl-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  @media screen and (min-width: 1201px) {
    width: 210.5px;
  }
}

.midl-cont-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  // margin-top: -24px;
  @media screen and (min-width: 1201px) {
    width: 210.5px;
  }
}

.rating-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */

  text-align: center;

  /* Gray/900 */

  color: #0f1734;
}
.rating-cont {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 88.53px;
  height: 48px;
}
.avatar-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px;
  gap: 8px;
  @media screen and (max-width: 1200px) {
    align-self: flex-start;
  }
}

.avatar-cont-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px;
  gap: 8px;
  @media screen and (max-width: 1200px) {
    align-self: flex-start;
    margin-top: 24px;
  }
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  // min-width: 112px;
  min-height: 22px;
  background: #e1eaf7;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #2a71d4;
}

.con {
  margin-bottom: 16px;
}
.loc-cont {
  display: flex;
  align-items: center;
  padding: 0px;

  width: fit-content;
  // min-height: 42px;
  @media screen and (min-width: 1201px) {
    min-width: 152px;
  }
}
.number {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}
.info-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  min-width: 213.5px;
  min-height: 111px;
}

.review-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */

  text-align: center;

  /* Gray/900 */

  color: #0f1734;
}
.cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 93px;
  height: 126px;
}
.prov-name {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  min-width: 112px;
  height: 22px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}
.card-container {
  border: 1px solid rgba(15, 116, 189, 0.3);
  border-radius: 6px;
  background-color: #ffffff;
  transition: 0.3s all linear;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;

  &:hover {
    border: 1px solid #a3cce6;
    background-color: #eff5fb;
    transform: scale(1.023);
  }
  .item-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px 16px;
    .user-img {
      height: 73px;
      width: 73px;
      cursor: pointer;
      border-radius: 50%;
      border: 1px solid #ccc;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
    }
    .rating {
      margin-top: 6px;
      padding: 1px 5px;
      border-radius: 10px;
      background-color: #f5b255;
      color: #ffffff;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .review {
      font-family: Lato;
      font-size: 8px;
      font-weight: bold;
      text-align: center;
      margin-top: 4px;
    }
  }
  .item-right {
    overflow: auto;
    flex: 1;
    padding: 22px 16px;

    .promoted-label {
      border-radius: 7px;
      background-color: rgba(247, 181, 0, 0.25);
      color: #f98e46 !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      align-self: center;
      text-align: center;
      padding: 4px 10px;
      width: 89px;
      margin: 0;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
    .provider-name {
      color: #333333;
      font-family: Lato;
      font-size: 20px;
      cursor: pointer;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .provider-title {
      color: rgba(51, 51, 51, 0.87) !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .provider-desc {
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      color: #0f74bd;
    }
    .tags {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 12px -5px 0 -5px;

      @media screen and (max-width: 900px) {
        margin-bottom: 5px;
      }

      .crown {
        border-radius: 7px;
        background-color: rgba(247, 181, 0, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
      .tag {
        border-radius: 7px;
        background-color: rgba(245, 178, 85, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
    }
    .btn-container1 {
      .btn-primary1 {
        border-radius: 17.5px;
        background-color: #f5b255;
        color: #ffffff;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        padding: 5px 6px;
        max-width: 126px;
        min-width: 99px;

        @media screen and (max-width: 900px) {
          padding: 7px 5px;
        }
      }
      .btn-secondary1 {
        border-radius: 17.5px;
        color: #f5b255;
        margin-top: 10px;
        background: #fff;
        font-family: Lato;
        font-size: 12px;
        padding: 5px 6px;
        font-weight: bold;
        text-align: center;
        max-width: 126px;
        min-width: 99px;
      }
    }
    .contact-number {
      color: #333333;
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
    }
    .address {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #94a3b8;
    }
    .distance {
      color: #333333;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      margin-left: 15px;
    }
  }
}
@media screen and (max-width: 581px) {
  .card-container .item-right .provider-name {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/provider/DoveMedRecommendedCard.vue